import { z } from 'zod';

export const FlowStatusSchema = z.object({
  ABORTED: z.literal('ABORTED'),
  EXCEPTION: z.literal('EXCEPTION'),
  FINISHED: z.literal('FINISHED'),
  PROCESSING: z.literal('PROCESSING'),
  WAITING_FOR_INPUT: z.literal('WAITING_FOR_INPUT'),
});
